function getApiBaseUrl() {
  if (import.meta.env.MODE === 'test') {
    return '';
  } else if (import.meta.env.MODE === 'development') {
    return import.meta.env.VITE_FUNCTIONS_PORT
      ? `http://localhost:${import.meta.env.VITE_FUNCTIONS_PORT}`
      : import.meta.env.VITE_FUNCTIONS_URL;
  } else {
    return import.meta.env.VITE_FUNCTIONS_URL_DEPLOY;
  }
}

export const API_BASE_URL = getApiBaseUrl();

function getDownloadBaseUrl() {
  if (import.meta.env.MODE === 'test') {
    return '';
  } else if (import.meta.env.MODE === 'development') {
    return import.meta.env.VITE_DOWNLOAD_PORT
      ? `http://localhost:${import.meta.env.VITE_DOWNLOAD_PORT}`
      : import.meta.env.VITE_FUNCTIONS_URL.replace('/api', '/download');
  } else {
    return import.meta.env.VITE_DOWNLOAD_URL_DEPLOY;
  }
}

export const DOWNLOAD_BASE_URL = getDownloadBaseUrl();
